import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { ProfileDataService } from 'src/app/header/perfil-usuario/service/profile-data.service';
import { HeaderService } from 'src/app/header/service/header.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { ModuloBusca, ModulosBuscaService } from 'src/app/shared/components/filtros-busca/service/modulos-service/modulos.service';

@Component({
  selector: 'app-modal-solicitar-nova-obra',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-solicitar-nova-obra.component.html',
  styleUrls: ['./modal-solicitar-nova-obra.component.scss']
})
export class ModalSolicitarNovaObraComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();
 
  private _profileDataService = inject(ProfileDataService);
  private _fichaDaObraService = inject(FichaDaObraService);
  private _headerService = inject(HeaderService);
  private readonly authService = inject(AuthService);
  private readonly _modulosService = inject(ModulosBuscaService);

  workName = '';
  city = '';
  state = '';
  constructorName = '';
  message = '';
  moduloId: number | null = null;
  modulos: ModuloBusca[] = [];

  companyId: number | null = null;
  companyName: string = '';
 
  sucesso = false;
  submitted = false;
  enviando = false;
 
  readonly estados = [
    'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA',
    'MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN',
    'RS','RO','RR','SC','SP','SE','TO'
  ];
 
  ngOnInit(): void {
    this._profileDataService.loadProfileData().subscribe();
    this.carregarDadosEmpresa();
    this.carregarModulos();
  }

  carregarModulos(): void {
    this._modulosService.getModulos().subscribe((modulos) => {
      const labelsMap: Record<number, string> = {
        234: 'Imobiliário',
        5: 'Industrial',
        6: 'Edificações',
        7: 'Infraestrutura',
      };
      this.modulos = modulos.map((modulo) => ({
        ...modulo,
        label: labelsMap[modulo.value] ?? modulo.label,
      }));
    });
  }

  carregarDadosEmpresa(): void {
    const companyId = localStorage.getItem('companyID');
    const restrictionKey = localStorage.getItem('restrictionKey');

    if (!companyId || !restrictionKey) {
      console.warn('companyID ou restrictionKey não encontrados no localStorage');
      return;
    }

    this._headerService.dadosFornecedor(companyId, restrictionKey).subscribe({
      next: (res) => {
        if (res && res.data) {
          this.companyId = res.data.companyID;
          this.companyName = res.data.tradingName || res.data.name || '';
        } else {
          console.warn('Resposta da API dadosFornecedor está vazia ou nula');
        }
      },
      error: (err) => {
        console.error('Erro ao carregar dados da empresa:', err);
      },
    });
  }
 
  get isValid(): boolean {
    return !!this.state && !!this.message.trim() && !!this.moduloId;
  }
 
  enviar(): void {
    this.submitted = true;
    if (!this.isValid || this.enviando) return;

    this.enviando = true;
    this.loading.emit(true);

    const profileData = this._profileDataService.getProfileData();
    const userId = this.authService.userID;

    const payload = {
      workName:        this.workName.trim(),
      city:            this.city.trim(),
      state:           this.state,
      constructorName: this.constructorName.trim() || null,
      moduleId:        this.moduloId,
      message:         this.message.trim() || null,
      userId:          userId ? parseInt(userId) : null,
      userName:        profileData?.name || '',
      userEmail:       profileData?.email || '',
      userPhone:       profileData?.phone || '',
      companyId:       this.companyId ? Number(this.companyId) : null,
      companyName:     this.companyName,
      options:         null,
    };

    this._fichaDaObraService.solicitarNovaObra(payload).subscribe({
      next: () => {
        this.sucesso = true;
        this.enviando = false;
        this.loading.emit(false);
      },
      error: () => {
        this.enviando = false;
        this.loading.emit(false);
      },
    });
  }
 
  fechar(): void {
    this.close.emit();
  }

}
